<template>
  <v-dialog v-model="showModal" fullscreen persistent>
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title style="font-size: 12pt" v-if="this.wybrany_klient != null && this.wybrany_terapeuta != null">{{this.readonly ? 'Wizyta rezerwowa:' : 'Edycja wizyty rezerwowej:'}} {{this.wybrany_klient.name + ' '+this.wybrany_klient.surname }} u {{this.wybrany_terapeuta.name + ' ' + this.wybrany_terapeuta.surname}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title>Dane pacjenta:</v-card-title>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <p>Imie i nazwisko pacjenta: {{this.wybrany_klient.name + ' '+this.wybrany_klient.surname}}</p>
                        <p>Telefon kontaktowy: {{this.wybrany_klient.phone}}</p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>Szczegóły wizyty rezerwowej</v-card-title>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12" v-if="filteredtypywizyt && filteredtypywizyt.length > 0">
                        <v-select :items="filteredtypywizyt" item-text="nazwa"
                                  label="Typ wizyty terapeuty" placeholder="Wybierz typ wizyty_terapeuty..."
                                  v-model="wybrany_typ_wizyty"
                                  return-object
                                  clearable
                                  :readonly="readonly"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6" md="6" sm="12">
                        <v-select v-model="priority" :items="priorities" label="Priorytet" :readonly="readonly"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12">
                        <v-textarea v-model="notes" label="Uwagi" :readonly="readonly"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>Terminy wizyty rezerwowej</v-card-title>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <ReserveSchedules :schedules.sync="reserveSchedules" :readonly="readonly"></ReserveSchedules>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="save()" v-if="!readonly">Zapisz</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="showModal = false">Zamknij</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import swal from "sweetalert";
import {reserveService, therapistsService} from "@/services";
import ReserveAddSchedule from "@/components/reserves/ReserveAddSchedule";
import ReserveSchedules from "@/components/reserves/ReserveSchedules";

export default {
  name: "EditReserve",
  components: {ReserveSchedules},
  props: ["id","visible","readonly"],
  data()
  {
    return {
      overlay: false,
      priority: 0,
      priorities: [
        {
          text: 'Normalny',
          value: 0
        },
        {
          text: 'Terapeuta',
          value: 1
        },
        {
          text: 'VIP',
          value: 2
        }
      ],
      wybrany_typ_wizyty: null,
      reserveSchedules: [],
      typywizyt:[],
      wybrany_terapeuta: null,
      wybrany_klient: null,
      notes: null
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    showError(text, close) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        if (close) {
          this.showModal = false
        }
      })
    },
    save() {
      this.overlay = true
      reserveService.updateReserve({
        id: this.id,
        priority: this.priority,
        notes: this.notes,
        typWizytyTerapeutyId: this.wybrany_typ_wizyty != null ? this.wybrany_typ_wizyty.id : 0,
        reserveSchedules: this.reserveSchedules
      }).then(() => {
        this.overlay = false
        this.$emit('close')
      }).catch(resp => {
        if (
            resp.response != null &&
            resp.response.data != null &&
            resp.response.data.error != null
        ) {
          this.showError( resp.response.data.error.message,false);
        } else {
          this.showError("Błąd zapisu wizyty rezerwowej",false);
        }

      })
    },
    getData()
    {
      this.overlay = true
      reserveService.getReserve(this.id).then(result => {
        this.wybrany_terapeuta = result.data.result.therapist
        this.wybrany_klient = result.data.result.client
        this.priority = result.data.result.priority
        this.notes = result.data.result.notes
        if(result.data.result.reserveSchedules != null)
          this.reserveSchedules = result.data.result.reserveSchedules
        if(result.data.result.therapistVisitType) {
          let type = this.filteredtypywizyt.find(x=>x.id == result.data.result.therapistVisitType.id)
          this.wybrany_typ_wizyty = type
        }
        this.overlay = false
      }).catch(()=> {
        this.overlay = false
        this.showError('Błąd pobierania informacji o wizycie rezerwowej',true)
      })
    },
    getAllTypyWizyt() {
      therapistsService.GetWszystkieTypyWizyt().then(result => {
        this.typywizyt = result.data.result
      }).catch(() => {
        this.error("Nie można pobrać typów wizyt terapeutów.");
      })
    },
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },
    filteredtypywizyt: function() {
      if(this.wybrany_terapeuta != null)
      {
        let lst = []
        lst = this.typywizyt.map(obj=> ({...obj, disabled: !obj.aktywna}))
        return lst.filter(x=>x.terapeuta_id == this.wybrany_terapeuta.id)
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>